<!-- 具体新闻内容 -->
<template>
    <div class="news_content_wrapper">
        <div class="news_content_item news_content_section1">
            <!-- 内容区域 -->
            <div class="bottom_wrapper">
                <div class="main_wrapper">  
                    <div class="content_title">{{this.article && this.article.title}}</div>
                    <div class="content_created">{{content_date}}</div>
                    <div class="content_wrapper" v-html='this.article && this.article.content'></div>
                    <div class="guide_wrapper">
                        <div class="prev" @click="bind_jump_content(content_prev)">上一篇： {{content_prev.title}}</div>
                        <div class="next" @click="bind_jump_content(content_next)">下一篇： {{content_next.title}}</div>
                    </div>
                </div>
            </div>
        </div>
        <BottomMsg/>
    </div>    
</template>

<script>
    import Swiper from 'swiper';
    import CmsForm from '@/components/CmsForm';
    import BottomMsg from '@/components/BottomMsg';
    import data from '@/data/case.js';
    import util from '@/util/util';
    import constant from '@/util/constant';
    import axios from 'axios';
    import jsonp from '@/util/jsonp';
    export default {
        name: "CaseContent",
        components: {
            CmsForm,
            BottomMsg
        },
        computed: {
           
        },
        data() {
            return {
                // 图像替换的标志
                img_loaded: false,
                article: {},
                content_date: '',
                content_prev: {},
                content_next: {},
                // 请求querystring
                apiOption: { showmethod: 'native', keyfrom: 'wap', client: 'wap', callback: 'jsonp_article' }
            }
        },
        watch: {
        　　'$route': function (to, from) {
                this.fetchData();
                let articleId = this.$route.params && this.$route.params.id;
                // 获取文章内容
                this.bind_get_article(articleId);
                this.img_loaded = false;
                // 复用router-view, 手动回到顶部
                window.scrollTo(0, 0);
        　　}
        },
        mounted() {
            window.jsonp_article = function(data) {};
            this.fetchData();
            let articleId = this.$route.params && this.$route.params.id;
            // 获取文章内容
            this.bind_get_article(articleId);
        },
        methods: {
            // 请求文章
            bind_get_article(id) {
                this.art_params = util.get_params(`sw/m/${id}`, this.apiOption); 
                jsonp(`//xue.youdao.com/${this.art_params}`, {}, {})
                    .then(result =>{  
                        this.article = result;
                        document.title = this.article.title;
                        // 页面图片替换（cms取回来的文章需要手动替换图片）
                        if (this.article.content) {
                            this.$nextTick(function () {
                                // 替换页面的img
                                if (!this.img_loaded) {
                                    // 替换img图片
                                    let imgList = document.querySelectorAll('.news_content_section1 img');
                                    [].forEach.call(imgList, function(img) {
                                        let real_url = img.getAttribute('dataimg');
                                        real_url && img.setAttribute('src', real_url);
                                    })  
                                    this.img_loaded = true;
                                }
                            })
                        }
                    }, err => {  
                        return err;  
                    }).catch(() => {
                        return {};
                    })
            },
            fetchData() {
                axios.get(`${constant.CMS_ADS}/dsp/ow_news.json`).then((res) => {
                    // 获取具体内容数据
                    this.content_data = res.data;
                    // 获取文章编号idx
                    let content_key = this.$route.params.id;
                    let { idx, content } = this.bind_get_content(this.content_data, content_key);
                    this.content = content;
                    this.content_date = this.content.date;
                    this.content_idx = idx;
                    this.content_prev = this.bind_get_prevandnext(this.content_data, this.content_idx, 'prev');
                    this.content_next = this.bind_get_prevandnext(this.content_data, this.content_idx, 'next');
                })
            },
            // 通过data和key找到相应的文章内容
            bind_get_content(data, key) {
                for (let i=0; i<data.length; i++) {
                    if (data[i].article_id == key) {
                        return { idx: i, content: data[i] };
                    }
                }
                return { idx: null, content: {} };
            },
            // 获取前一篇or后一篇文章的内容
            bind_get_prevandnext(data, key, flag) {
                let len = data.length;
                if (flag == 'prev') {
                    let pre_idx = key - 1;
                    if (pre_idx < 0) {
                        return {
                            name: '没有了',
                            end: true
                        }
                    } else {
                        return data[pre_idx];
                    }
                } else if (flag == 'next') {
                    let next_idx = key + 1;
                    if (next_idx > len - 1) {
                        return {
                            name: '没有了',
                            end: true
                        }
                    } else {
                        return data[next_idx];
                    }
                }
            },
            // 跳转上下篇
            bind_jump_content(content) {
                let isend = content.end;
                let idx = content.article_id;
                if (isend) {
                    this.$message({
                        message: '已经没有啦',
                        center: true,
                        type: 'error',
                        duration: 1000
                    })
                } else {
                    this.$router.push({
                        path: `/news_content/${idx}`
                    })
                }
            }
        }
    }
</script>

<style>
    /* 整个首页的包裹样式 */
    .news_content_wrapper {
        min-width: 1280px;
        text-align: center;
        overflow: auto;
    }
    /* 页面每个部分的通用样式 */
    .news_content_item {
        overflow: hidden;
        width: 100%;
    }
    /* 第一部分的样式 */
    .news_content_section1 {
        position: relative;
    }
    /* 内容区域 */
    .news_content_section1 .bottom_wrapper {
        padding-top: 48px;
        padding-bottom: 32px;
        background: #f7f8fa;
        z-index: 100;
    }
    /* 主要文章内容样式 */
    .news_content_section1 .main_wrapper {
        z-index: 100;
        position: relative;
        padding: 96px 60px 48px 60px;
        width: 1280px;
        margin: auto;
        border-radius: 4px;
        box-shadow: 0 2px 30px 0 rgba(204,230,255,0.36);
        background: #FFFFFF;
        overflow: hidden;
    }
    /* 内容 */
    .main_wrapper .content_wrapper {
        padding: 0 150px;
        text-align: left;
    }   
    /* 标题 */
    .content_title {
        font-size: 36px;
        color: #292c33;
        text-align: center;
        line-height: 54px;
        margin-bottom: 8px;
    }
    /* 时间 */
    .content_created {
        font-size: 14px;
        color: #aaadb3;
        text-align: center;
        line-height: 31px;
        margin-bottom: 48px;
    }
    /* 导航条 */
    .main_wrapper .guide_wrapper {
        padding-top: 48px;
        border-top: 1px solid #f0f0f0;
    }

    .guide_wrapper * {
        cursor: pointer;
        font-size: 14px;
        color: #636770;
        line-height: 14px;
    }

    .guide_wrapper *:hover {
        text-decoration: underline;
    }
    /* 前一页 */
    .guide_wrapper .prev {
        margin-left: 150px;
        float: left;
    }
    /* 后一页 */
    .guide_wrapper .next {
        margin-right: 150px;
        float: right;
    }
    /* cms看天下文章样式覆盖 */
    .news_content_section1 blockquote {
        color: #999;
        font-size: .186667rem;
        margin: .333333rem auto;
        padding-left: .106667rem;
        border-left: .053333rem solid #ebebeb;
        font-family: "Helvetica Neue",Helvetica,sans-serif;
    }
    .news_content_section1 blockquote p {
        line-height: 1.5;
    }
    .news_content_section1  a {
        color: #4784b2;
        text-decoration: none;
    }
    .news_content_section1 img {
        /* width: 100%; */
        max-width: 100%;
        width: auto;
        height: auto;
        margin: .2rem 0;
        display: inline-block;
    }
    .news_content_section1 p {
        margin: 20px !important;
    }
</style>





// WEBPACK FOOTER //
// src/containers/News/NewsContent.vue